<template>
  <div class="loader-overlay">
    <div class="loader-container">
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IsLoadingComponent',
  data: () => ({
    overlay: true,
  }),
}
</script>
<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(128, 128, 128, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2008;
  margin:-60px;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(46, 88, 129, 0.2);
  border-top: 4px solid #2E5881;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
